import type { ErrorResponse } from "@apollo/client/link/error";
import * as Sentry from "@sentry/react";
import type { GraphQLFormattedError } from "graphql";

const HANDLED_MESSAGES = new Set([
  "Access token expired",
  "jwt expired",
  "User session not found",
  "Session expired due to inactivity",
  "Access token is missing",
]);

const toError = (message: string) =>
  Object.assign(new Error(message), { name: "GraphQLError" });

const isReportable = ({ message }: GraphQLFormattedError) =>
  !HANDLED_MESSAGES.has(message);

export const reportErrors = ({
  graphQLErrors = [],
  networkError,
  operation,
}: ErrorResponse) => {
  const { operationName } = operation;

  for (const error of graphQLErrors.filter(isReportable)) {
    Sentry.captureException(toError(error.message), {
      tags: {
        "graphql.operation": operationName,
        "graphql.code": String(error.extensions?.code ?? "UNKNOWN"),
      },
      extra: { path: error.path },
      fingerprint: ["graphql", operationName, error.message],
    });
  }

  if (
    networkError &&
    "statusCode" in networkError &&
    networkError.statusCode >= 500
  ) {
    Sentry.captureException(networkError, {
      tags: {
        "graphql.operation": operationName,
        "http.status_code": String(networkError.statusCode),
      },
    });
  }
};
